// Application-wide constants — single source of truth for magic values

// ── User roles ─────────────────────────────────────────────────────────────
export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  EDITOR: 'editor',
  COMMITTEE: 'committee',
  PARENT: 'parent',
  STUDENT: 'student',
}

// Role groups
export const EDIT_CAPABLE_ROLES = [ROLES.ADMIN, ROLES.MANAGER, ROLES.EDITOR]
export const PARLIAMENT_ADMIN_ROLES = [ROLES.ADMIN, ROLES.MANAGER, ROLES.COMMITTEE]
export const USER_MANAGER_ROLES = [ROLES.ADMIN, ROLES.MANAGER]
/** Roles that can enter admin dashboard */
export const ADMIN_ACCESS_ROLES = [ROLES.ADMIN, ROLES.MANAGER, ROLES.EDITOR, ROLES.COMMITTEE]

// ── Firestore collection names ──────────────────────────────────────────────
export const COLLECTIONS = {
  APP_USERS: 'appUsers',
  TRANSLATIONS: 'translations',
  IMAGES: 'images',
  CONTACTS: 'contacts',
  PARLIAMENT_DATES: 'parliamentDates',
  PARLIAMENT_SUBJECTS: 'parliamentSubjects',
  RATE_LIMITS: 'rateLimits',
  AUDIT_LOGS: 'auditLogs',
}

// ── Cache TTLs ─────────────────────────────────────────────────────────────
export const CACHE_TTL = {
  /** Public / publish mode cache TTL */
  PUBLIC_MS: 5 * 60 * 1000,
  /** Edit mode cache TTL */
  EDIT_MS: 2 * 60 * 1000,
  /** Firestore in-page cache TTL */
  DB_MS: 5 * 60 * 1000,
}

// ── Translation loading timeouts ────────────────────────────────────────────
export const LOAD_TIMEOUT_MS = 8000
export const SAFETY_MAX_MS = 12000

// ── Auth / session ──────────────────────────────────────────────────────────
/** Firebase custom token expiry (seconds) */
export const ADMIN_TOKEN_EXPIRY_SECONDS = 3600

// ── Rate limiting ───────────────────────────────────────────────────────────
export const RATE_LIMIT = {
  /** Max failed login attempts before lockout */
  MAX_ATTEMPTS: 5,
  /** Sliding window in ms */
  WINDOW_MS: 15 * 60 * 1000,
}

// ── ImageKit ────────────────────────────────────────────────────────────────
export const IMAGEKIT_URL_ENDPOINT = 'https://ik.imagekit.io/fzv0y7xbu'
export const IMAGEKIT_PUBLIC_KEY = 'public_Ubfj3JyFAbabaMCqAGRpVj+Jy7c='
export const IMAGEKIT_FOLDER = '/school-website/'
